import { Edit, MoreVertical, Trash2 } from 'lucide-react'
import { Badge } from '@/shared/components/ui/badge'
import { Button } from '@/shared/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/shared/components/ui/dropdown-menu'
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/shared/components/ui/table'
import type { Contacto } from '@/modules/bd-unificada/types/contacto'
import { TIPOS_CONTACTO } from '@/modules/bd-unificada/types/contacto'

interface ContactosTableProps {
  contactos: Contacto[]
  canEdit: boolean
  onEdit: (contacto: Contacto) => void
  onDelete: (contacto: Contacto) => void
}

function labelTipo(tipo: string): string {
  return TIPOS_CONTACTO.find((t) => t.value === tipo)?.label ?? tipo
}

export function ContactosTable({ contactos, canEdit, onEdit, onDelete }: ContactosTableProps) {
  return (
    <div className="rounded-md border border-gray-300 dark:border-gray-700 overflow-hidden">
      <Table>
        <TableHeader className="bg-gray-100 dark:bg-[hsl(220,15%,16%)]">
          <TableRow>
            <TableHead>Nombre</TableHead>
            <TableHead>Tipo</TableHead>
            <TableHead>Cédula</TableHead>
            <TableHead>Email preferido</TableHead>
            <TableHead>Teléfono</TableHead>
            <TableHead>Especialidad</TableHead>
            <TableHead>Ubicación</TableHead>
            <TableHead className="text-right">Acciones</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {contactos.map((c) => (
            <TableRow key={c.id}>
              <TableCell className="font-medium">{c.nombre_completo}</TableCell>
              <TableCell>
                <Badge className="badge-gradient hover:opacity-90 capitalize">
                  {labelTipo(String(c.tipo))}
                </Badge>
              </TableCell>
              <TableCell>{c.cedula || '—'}</TableCell>
              <TableCell className="text-sm">{c.email_preferido || '—'}</TableCell>
              <TableCell>{c.telefono || '—'}</TableCell>
              <TableCell>{c.especialidad || '—'}</TableCell>
              <TableCell className="text-sm text-muted-foreground">
                {[c.ciudad, c.provincia, c.pais].filter(Boolean).join(', ') || '—'}
              </TableCell>
              <TableCell className="text-right">
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button size="sm" variant="ghost" className="h-8 w-8 p-0">
                      <MoreVertical className="h-4 w-4" />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end">
                    <DropdownMenuItem onClick={() => onEdit(c)} disabled={!canEdit}>
                      <Edit className="mr-2 h-4 w-4" /> Editar
                    </DropdownMenuItem>
                    <DropdownMenuItem
                      onClick={() => onDelete(c)}
                      disabled={!canEdit}
                      className="text-destructive focus:text-destructive"
                    >
                      <Trash2 className="mr-2 h-4 w-4" /> Eliminar
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  )
}
